import { parseScheduleWindows } from '@provision/sidekick-utils';
import type { RuleType } from 'react-querybuilder';
import { buildDefaultScheduleWindows } from 'src/components/ScheduleConditionEditor';
import { ConditionType } from 'src/graphql/entities/behavior/behavior-config/behavior-config.types';
import type { SelectorValue } from 'src/graphql/entities/behavior/behavior.types';

/**
 * The value a condition row resets to when its field or operator changes. A Custom schedule row
 * keeps the windows it already holds — switching Within ⇄ Outside must not drop the days and
 * times — and a freshly picked one starts complete (weekdays 09:00–17:00). Every other row starts
 * empty, which is what the library default gives these object fields.
 */
export function getConditionDefaultValue(rule: RuleType): unknown {
  const field = rule.field as unknown as SelectorValue | undefined;
  if (field?.conditionType !== ConditionType.CustomSchedule) {
    return '';
  }

  // plain copies: the rule is an immer draft while the library resets it
  const windows = parseScheduleWindows(rule.value).map((window) => ({ ...window }));
  return windows.length ? windows : buildDefaultScheduleWindows();
}
